// extracted by mini-css-extract-plugin
export default {"customFileUpload":"BulkLoginMobile_customFileUpload__vPXJZ"};